/**
 * État vide : aucun ingrédient ajouté
 */

import React from "react";
import { motion } from "framer-motion";
import { glassPanel } from "../../../../components/layout/UserLayout/designTokens";
import { quickStartIngredients } from "../constants/ingredients.js";

export default function EmptyState({ addIngredient, getIngredientLabel, t }) {
  return (
    <motion.div
      className={`${glassPanel} rounded-2xl p-8 sm:p-10 text-center`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="text-5xl sm:text-6xl mb-4">🧊</div>
      <h3 className="text-xl font-bold text-ink-900 dark:text-white mb-2">
        {t("startByAddingIngredients")}
      </h3>
      <p className="text-ink-600 dark:text-white/80 text-sm max-w-md mx-auto mb-6">
        {t("addIngredientsDescription")}
      </p>
      <p className="text-xs text-ink-500 dark:text-white/60 mb-3">
        {t("suggestionsToStart") || "Cliquez pour ajouter :"}
      </p>
      <div className="flex flex-wrap justify-center gap-2">
        {quickStartIngredients.map((ing) => (
          <button
            key={ing}
            type="button"
            onClick={() => addIngredient(ing)}
            className="px-4 py-2 bg-orange-100 hover:bg-orange-200 text-orange-800 rounded-xl text-sm font-medium border border-orange-300 dark:bg-orange-500/30 dark:hover:bg-orange-500/50 dark:text-white dark:border-orange-400/50 transition-colors"
          >
            + {getIngredientLabel(ing)}
          </button>
        ))}
      </div>
    </motion.div>
  );
}
